import { render, staticRenderFns } from "./save-template-modal.vue?vue&type=template&id=52be17d0"
import script from "./save-template-modal.vue?vue&type=script&lang=js"
export * from "./save-template-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports